<template>
    <v-content v-if="userIsAuthenticated">
        <v-container>
            <v-row>
                <h1 class="font-weight-bold" :style="`color:${mainColor}`">Base de información</h1>
            </v-row>
            <v-row class="pt-5 body-2">
                <p>Ingresa información sobre tu empresa que sea relevante para tus usuarios, como ser horarioss de atención, formas de pago, envíos, etc</p>
            </v-row>
            <v-row>
              <v-col>
                <template>
                  <v-spacer></v-spacer>
                  <loading-dialog :onLoading="onLoading" />
                </template>
              </v-col>
            </v-row>
            <v-row  >
              <v-col cols="12">
                <v-form @submit.prevent="onSubmitCompanyData">
                    <v-row class="mb-3">
                      <v-col cols="2" offset="5">
                        <v-text-field
                          v-model="exRate"
                          type="number"
                          outlined
                          label="Tipo de cambio USD a Bs"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <h2>Costo de envío</h2>
                        <v-row class="ml-4">
                          <v-col cols="10" offset="1">
                              <h4>Zonas:</h4>
                            <v-row>
                              <v-col
                                cols="3"
                                v-for="(el, index) in shippingCost"
                                :key="index"
                              >
                                <v-text-field
                                  v-model="el.cost"
                                  :label="el.zone"
                                  type="number"
                                  outlined
                                  suffix="Bs"
                                >
                                </v-text-field>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <h2>Horario de envío</h2>
                        <v-row class="ml-4">
                          <v-col cols="10" offset="1">
                              <h4>Días:</h4>
                            <v-row>
                              <v-col
                                cols="3"
                                v-for="(el, index) in shippingDays"
                                :key="index"
                              >
                                <v-checkbox
                                  v-model="el.enable"
                                  :label="el.day"
                                >
                                </v-checkbox>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row class="ml-4">
                          <v-col cols="10" offset="1">
                              <h4>Turno:</h4>
                            <v-row>
                              <v-col
                                cols="3"
                                v-for="(el, index) in shippingDayTurn"
                                :key="index"
                              >
                                <v-checkbox
                                  v-model="el.enable"
                                  :label="el.turn"
                                >
                                </v-checkbox>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-row>
                          <h2>Repuestas del bot</h2>
                        </v-row>
                        <v-row class="pt-5 body-2">
                          <v-col cols="10" offset="1">
                            <p>Escribe las respuestas que el bot dirá cuando se le pregunte sobre un asunto relevante para tu empresa.</p>
                            <p>Por ejemplo, si te preguntan el horario de atención, en asunto selecciona "Horarios" y escribe la respuesta informando el horario de atención de tu empresa.</p>
                          </v-col>
                        </v-row>
                        <v-content
                            v-for="(item, index) in companyData"
                            :key="index"
                            class="pa-0"
                        >
                          <v-row>
                            <v-col cols="10" offset="1">
                              <v-row>
                                <v-col cols="12">
                                  <v-card style="position: relative;">
                                    <v-container>
                                      <v-row>
                                        <v-col cols="12">
                                            <v-card-title class="pb-7">
                                              <h2>
                                                {{item.type}}
                                              </h2>
                                            </v-card-title>
                                            <v-card-subtitle v-if="item.type !== ''">
                                              <p>{{contentAnswer(item.type)}}</p>
                                            </v-card-subtitle>
                                        </v-col>
                                      </v-row>
                                      <v-row>
                                        <v-col cols="4" offset="4">
                                            <v-select
                                                v-model="item.type"
                                                :items="contentTypes"
                                                label="Elige el asunto"
                                                id="contentType"
                                                solo
                                                @change="addKeyword(index)"
                                            ></v-select>
                                        </v-col>
                                        <v-col v-if="index >= 1" >
                                            <v-btn
                                                @click="removeInfoBlock(index)"
                                                dark
                                                fab
                                                small
                                                icon
                                                color="grey"
                                            ><v-icon>{{deleteIcon}}</v-icon>
                                            </v-btn>
                                        </v-col>
                                        <v-col v-else-if="index === 0 && item.type !== ''" >
                                            <v-btn
                                                @click="removeInfoBlock(index)"
                                                dark
                                                fab
                                                small
                                                icon
                                                color="grey"
                                            ><v-icon>{{deleteIcon}}</v-icon>
                                            </v-btn>
                                        </v-col>
                                      </v-row>
                                      <v-row  >
                                        <v-col cols="12">
                                          <v-row class="pb-5 pl-5" v-if="item.type === 'otro'">
                                              <v-col cols="8" >
                                                  <v-combobox
                                                      v-model="item.keywords"
                                                      hide-selected
                                                      hint="Agrega palabras que describan el asunto."
                                                      label="Escribe la palabra clave y preciona enter."
                                                      multiple
                                                      persistent-hint
                                                      small-chips
                                                      deletable-chips
                                                      @change="toLowerCase(index)"
                                                  ></v-combobox>
                                              </v-col>
                                          </v-row>
                                          <v-row class="pb-5 pl-5 pr-5">
                                              <v-col  cols="12" >
                                                  <v-textarea
                                                      v-model="item.content"
                                                      name="content"
                                                      label="Escribe la respuesta del bot."
                                                      :counter="max2"
                                                      :rules="[rules.counter2, rules.required]"
                                                      multi-line
                                                      filled
                                                      required
                                                  ></v-textarea>
                                              </v-col>
                                          </v-row>
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-card>
                                </v-col>
                              </v-row>
                              <v-row class="text-center pb-4" >
                                <v-col class="mt-4" cols="12" v-if="index + 1 === companyData.length" >
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{on}">
                                            <v-btn
                                                @click="addInfoBlock(index)"
                                                dark
                                                fab
                                                icon
                                                :color="mainColor"
                                                v-on="on"
                                                x-large
                                            ><v-icon>{{addIcon}}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Agregar contenido</span>
                                    </v-tooltip>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-content>
                      </v-col>
                    </v-row>
                    <v-row
                    >
                      <v-col
                        class="text-right pa-0"
                        cols="12"
                      >
                        <v-btn
                          type="submit"
                          :disabled="onLoading"
                          :loading="onLoading"
                          :color="mainColor"
                          dark
                          small
                          style="position: fixed; top: 65px; right: 15px;"
                        >
                        Guardar
                          <span slot="loader" class="custom-loader">
                              <v-icon light>cached</v-icon>
                          </span>
                        </v-btn>
                      </v-col>
                    </v-row>
                </v-form>
              </v-col>
            </v-row>
        </v-container>
    </v-content>
</template>
<script>
/* eslint-disable no-console */
import * as constants from '../../../constants.json'

import {
  mdiDeleteOutline,
  mdiPlusCircle
} from '@mdi/js'

export default {
  data () {
    return {
      currency: 'Bs',
      shippingCost: [{ // Temporal, buscar mejor solución
        zone: '',
        cost: 0
      }],
      shippingDays: [
        { day: 'Lunes', enable: false },
        { day: 'Martes', enable: false },
        { day: 'Miércoles', enable: false },
        { day: 'Jueves', enable: false },
        { day: 'Viernes', enable: false },
        { day: 'Sabádo', enable: false },
        { day: 'Domingo', enable: false }
      ],
      shippingDayTurn: [
        { turn: 'Mañana', enable: false },
        { turn: 'Tarde', enable: false },
        { turn: 'Mañana-Tarde', enable: false }
      ],
      exRate: 0,
      companyData: [ // The knowledge base
        {
          content: '',
          keywords: [],
          type: ''
        }
      ],
      companyId: '',
      max1: 80, // Short description Max character allowed in manychat card subtitle.
      max2: 1000, // Flow text, Max character allowed in manychat.
      max3: 45, // Max character allowed in manychat card title.
      mainColor: constants.MAINCOLOR,
      style: {
        border: '1px solid #e1e1e1',
        fontColor: '#525252'
      },
      rules: {
        counter1: value => (value || '').length <= this.max1 || `Sólo se permite un máximo de ${this.max1} caracteres`,
        counter2: value => (value || '').length <= this.max2 || `Sólo se permite un máximo de ${this.max2} caracteres`,
        counter3: value => (value || '').length <= this.max3 || `Sólo se permite un máximo de ${this.max3} caracteres`,
        required: value => !!value || 'Campo requerido'
      },
      deleteIcon: mdiDeleteOutline,
      addIcon: mdiPlusCircle
    }
  },

  watch: {
    /**
     * Fetching data if user is authenticated
     */
    async user (value) {
      // eslint-disable-next-line
      console.log('value', value)
      if (value === null || value === undefined) {
        this.$router.push('/')
      } else {
        await this.fetchData()
      }
    }
  },

  created () {
    // Fetching the data when the view is created and the data is already being observed
    this.fetchData()
  },
  computed: {
    /**
     * Show the Loading animation.
     */
    onLoading () {
      // eslint-disable-next-line
      console.log('loading ', this.$store.getters.getLoading)
      return this.$store.getters.getLoading
    },

    /**
     * Content type options
     */
    contentTypes () {
      return [
        'Costo de envío',
        'Dirección',
        'Formas de pago',
        'Horarios',
        'IVA',
        'Política de envío',
        'Tipo de cambio',
        'otro'
      ]
    },

    user () {
      return this.$store.getters.getUser
    },

    userIsAuthenticated () {
      return this.$store.getters.getUser !== null && this.$store.getters.getUser !== undefined
    }
  },

  methods: {
    /**
     * Fetch data
     */
    async fetchData () {
      try {
        const user = this.$store.getters.getUser
        if (user) {
          if (user.role === 'mega_administrator') {
            this.companyId = await localStorage.companyId
          } else {
            const companyData = this.$store.getters.getCompanyData
            this.companyId = companyData.companyId
          }
          await this.$store.dispatch('loadBotInfo', { companyId: this.companyId })
          const companyInfo = this.$store.getters.getBotInfo

          if (companyInfo.companyData.length > 0) {
            this.companyData = companyInfo.companyData
            this.companyData.forEach(data => {
              if (data.type === 'address') data.type = 'Dirección'
              if (data.type === 'exchange_rate') data.type = 'Tipo de cambio'
              if (data.type === 'office_hours') data.type = 'Horarios'
              if (data.type === 'other') data.type = 'otro'
              if (data.type === 'payment_method') data.type = 'Formas de pago'
              if (data.type === 'shipping_cost') data.type = 'Costo de envío'
              if (data.type === 'shipping_policy') data.type = 'Política de envío'
              if (data.type === 'taxe_policy') data.type = 'IVA'
            })
          }

          this.currency = companyInfo.currency === '' ? 'Bs' : companyInfo.currency
          // this.shippingCost = companyInfo.shippingCost
          this.exRate = companyInfo.exRate
          console.log('companyInfo: ', companyInfo)

          const shippingZone = [
            '1er anillo',
            '2do anillo',
            '3er anillo',
            '4to anillo',
            '5to anillo',
            '6to anillo',
            '7mo anillo',
            '8vo anillo',
            '9no anillo'
          ]

          shippingZone.forEach((zone, index) => {
            if (index === 0) {
              this.shippingCost[index].zone = zone
              this.shippingCost[index].cost = 0
            } else {
              this.shippingCost.push({
                zone,
                cost: 0
              })
            }
          })

          companyInfo.shippingCost.forEach((el, index) => {
            this.shippingCost[index].zone = el.zone
            this.shippingCost[index].cost = el.cost
          })

          console.log('this.shippingCost', this.shippingCost)
        }
      } catch (error) {
        throw error
      }
    },

    /**
     * Submit company data
     */
    async onSubmitCompanyData () {
      if (this.exRate === 0) {
        alert('Error: El tipo de cambio no puede ser cero.')
        return
      } else if (this.companyData[0].type === '') {
        alert('Por favor, agrega alguna información antes de continuar.')
        return
      }
      const companyData = []

      let index = 0
      for (const data of this.companyData) {
        companyData.push({
          content: '',
          keywords: [],
          type: ''
        })
        if (data.type === 'Costo de envío') companyData[index].type = 'shipping_cost'
        if (data.type === 'Dirección') companyData[index].type = 'address'
        if (data.type === 'Horarios') companyData[index].type = 'office_hours'
        if (data.type === 'Formas de pago') companyData[index].type = 'payment_method'
        if (data.type === 'Tipo de cambio') companyData[index].type = 'exchange_rate'
        if (data.type === 'IVA') companyData[index].type = 'taxe_policy'
        if (data.type === 'Política de envío') companyData[index].type = 'shipping_policy'
        if (data.type === 'otro') companyData[index].type = 'other'
        if (data.type === '') {
          alert('Error: No has seleccionado el tipo de asunto.')
          return
        }

        companyData[index].content = data.content
        companyData[index].keywords = [...data.keywords]
        index++
      }

      console.log('companyData: ', companyData)
      this.$store.dispatch('actionSubmitCompanyData', {
        companyId: this.companyId,
        companyData,
        currency: this.currency,
        shippingCost: [ ...this.shippingCost ],
        shippingDayTurn: [ ...this.shippingDayTurn ],
        shippingDays: [ ...this.shippingDays ],
        exRate: this.exRate
      })
    },

    /**
     * Adding new content block
     */
    addInfoBlock (index) {
      // Don't add anything if there is an empty content block
      let checkEmptyContent = this.companyData.filter(el => el.content === '')
      if (checkEmptyContent.length >= 1) { return }

      // Push the elements to companyData
      this.companyData.push({
        content: '',
        keywords: [],
        type: ''
      })
    },

    /**
     * Removing  content block
     */
    removeInfoBlock (index) {
      if (index === 0 && this.companyData.length === 1) {
        this.companyData[0].content = ''
        this.companyData[0].keywords = []
        this.companyData[0].type = ''
      } else {
        this.companyData.splice(index, 1)
      }
    },

    /**
     * Add keyword if type is equal to 'address', 'exchange_rate' or 'office_hours'
     */
    addKeyword (index) {
      this.companyData[index].keywords.pop()

      if (this.companyData[index].type === 'Costo de envío') {
        this.companyData[index].keywords.push('costo de envio')
      }

      if (this.companyData[index].type === 'Política de envío') {
        this.companyData[index].keywords.push('politica de envio')
      }

      if (this.companyData[index].type === 'Dirección') {
        this.companyData[index].keywords.push('direccion')
      }

      if (this.companyData[index].type === 'Formas de pago') {
        this.companyData[index].keywords.push('metodos de pago')
      }

      if (this.companyData[index].type === 'IVA') {
        this.companyData[index].keywords.push('iva')
      }

      if (this.companyData[index].type === 'Horarios') {
        this.companyData[index].keywords.push('horarios')
      }

      if (this.companyData[index].type === 'Tipo de cambio') {
        this.companyData[index].keywords.push('tipo de cambio')
      }
    },

    /**
     * Convert to lower case
     */
    async toLowerCase (index) {
      const lowerCase = this.companyData[index].keywords.map(keyword => keyword.toLowerCase())
      await this.$nextTick()
      this.companyData[index].keywords = [...lowerCase]
    },

    /**
     * Answers examples
     */
    contentAnswer (type) {
      let answer = ''
      switch (type) {
        case 'Costo de envío':
          answer = 'Por ejemplo: "El costo de envío es de 15 Bs dentro del 5to anillo y 40 Bs hasta el 9no."'
          break
        case 'Dirección':
          answer = 'Por ejemplo: "Estamos ubicados en la Av. Beni Nro. 345"'
          break
        case 'Formas de pago':
          answer = 'Por ejemplo: "Puede pagar por transferencia bancaria o en efectivo contra entrega."'
          break
        case 'Horarios':
          answer = 'Por ejemplo: "Atendemos de lunes a viernes, de 8 am a 3pm."'
          break
        case 'IVA':
          answer = 'Por ejemplo: "Todos nuestros productos tienen IVA"'
          break
        case 'Política de envío':
          answer = 'Por ejemplo: "Hacemos envíos de lunes a viernes solamente por la mañana."'
          break
        case 'Tipo de cambio':
          answer = 'Por ejemplo: "Aceptamos el dolar a 6.9"'
          break
        case 'otro':
          answer = 'CUalquier otra información que quieras compartir con tus usuarios'
          break
      }
      return answer
    }
  }
}
</script>
